import cn from 'classnames';
import styles from './tableWrapper.module.scss';
import headerStyles from '@dealroadshow/uikit-styles/headers.module.scss';
import cardStyles from '@dealroadshow/uikit-styles/card.module.scss';
import spacesStyles from '@dealroadshow/uikit-styles/helpers/spaces.module.scss';

interface IProps {
  children: React.ReactNode,
  className?: string,
  contentClassName?: string,
  headerClassName?: string,
  labelClassName?: string,
  filterActionsClassName?: string,
  filterComponent?: React.ReactNode,
  label?: string,
  toolbar?: React.ReactNode,
}

const TableWrapper = (props: IProps) => (
  <>
    <div className={ cn(styles.tableWrapperContainer, props.className) }>
      <div className={ cn(cardStyles.cardHeader, props.headerClassName) }>
        { props.label && (
          <div className={ cn(cardStyles.cardHeaderTitle, headerStyles.isH3, spacesStyles.ptm, props.labelClassName) }>
            { props.label }
          </div>
        ) }
        { props.toolbar }
        { props.filterComponent && (
          <div className={ cn(cardStyles.cardHeaderActions, props.filterActionsClassName) }>
            { props.filterComponent }
          </div>
        ) }
      </div>
    </div>
    <div className={ cn(styles.tableWrapperContent, props.contentClassName) }>
      { props.children }
    </div>
  </>
);

export default TableWrapper;
